import client from '../client';
export interface GetSlipResponse {
  reference_id: string;
  slip_url: string;
  transaction_id: number;
  amount: number;
  status: string;
  transaction_type: string;
  created_at: string;
  updated_at: string;
}

export interface APIResponse<T> {
  success: boolean;
  data: T;
}

export type GetSlipAPIResponse = APIResponse<GetSlipResponse>;

export default function API(reference_id: string): Promise<GetSlipAPIResponse> {
  return client
    .get(`payment_v2/transaction/slip/${reference_id}`)
    .then((response) => response.data);
}
